import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Header from "./component/header/navbar";
import HeroSection from "./component/mainSection/heroSection";
import Footer from "./component/footer/footerNew";
import AboutSection from "./component/mainSection/aboutSection";
import Offered from "./component/mainSection/offeredSection";
import Choose_us from "./component/mainSection/choose_us";
import ExploreOurMenu from "./component/mainSection/exploreOurMenu";
import OurEsteemedClients from "./component/mainSection/ourEsteemedClients";
import OurAwesomeTeam from "./component/mainSection/ourAwesomeTeam";
import AboutUs from "./component/pages/about_us/index";
import About from "./component/pages/about_us/about";
import Journey from "./component/pages/about_us/journey";
import Careers from "./component/pages/careers/careersSection";
import Culturet from "./component/pages/culture/index";
import Our_team from "./component/pages/our_team/index";
import Staffing from "./component/pages/staffing";
import Services from "./component/pages/services/index";
import Web_devlopment from "./component/pages/services/web_devlopment";
import Mobile_development from "./component/pages/services/mobile_devlopment/mobile_development";
import AIML_development from "./component/pages/services/Ml_Developmenet/aiMlDevelopmenet";
import ECommerce from "./component/pages/services/E-Commerce-development/e-Commerce";
import ManagedServices from "./component/pages/services/managedServices/managedServices";
import Portfolio from "./component/pages/portfolio/portfolio";
import Countact_us from "./component/pages/countact_us/countact_us";
import ScrollTop from "./ScrollToTop";
import StaffingSolution from "./component/pages/staffing/staffingSolution";
import Home from "./component/mainSection/home";
import Testimonials from "./component/mainSection/testimonials";
import BlogPage from "./component/footer/blogPage";
import BlogDetail from "./component/footer/blogDetail/BlogDetail";
import ITStaffingServices from "./component/footer/blogDetail/ITStaffingServices";
import DelayedRecruitment from "./component/footer/blogDetail/DelayedRecruitment";
import StaffingSolutions from "./component/footer/blogDetail/StaffingSolutions";
import HelpYourBusiness from "./component/footer/blogDetail/HelpYourBusiness";
import GlobalITStaffingSolutions from "./component/footer/blogDetail/GlobalITStaffingSolutions";
import SmallToBigBusinessCompany from "./component/footer/blogDetail/SmallToBigBusinessCompany";
import BusinessExcellence from "./component/footer/blogDetail/BusinessExcellence";
import InternetMarketingServices from "./component/footer/blogDetail/InternetMarketingServices";
import MobileAppDevelopment from "./component/footer/blogDetail/MobileAppDevelopment";
import AngulerJsWebPage from "./component/footer/blogDetail/AngulerJsWebPage";
import JAVAandDotNet from "./component/footer/blogDetail/JAVAandDotNet ";
import AIMLBlog from "./component/footer/blogDetail/AIMLBlog";
import WordPressWebsite from "./component/footer/blogDetail/WordPressWebsite";
import "@fortawesome/fontawesome-free/css/all.min.css";
import NotFound from "./component/pages/NotFound";
import WhyAndFaqSection from "./component/mainSection/WhyAndFaqSection ";
import ItStaffAugmentation2026 from "./component/footer/blogDetail/ItStaffAugmentation2026";
import BlogDetailFormat  from "./component/footer/BlogDetailFormat";

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-8VTH6E2D2W", {
        page_path: location.pathname + location.search,
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function App() {
  new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries()) {
      console.log("Layout shift:", entry);
    }
  }).observe({ type: "layout-shift", buffered: true });

  return (
    <Router>
      <PageTracker />

      <Header />

      <Routes>
        <Route
          path="/"
          element={
            <div>
              <ScrollTop />
              <HeroSection />
              <Home />
              <Testimonials />
              <WhyAndFaqSection />
              <OurAwesomeTeam />
            </div>
          }
        />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about-tekit" element={<About />} />
        <Route path="/tekit-journey" element={<Journey />} />
        <Route path="/culture" element={<Culturet />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/our-team" element={<Our_team />} />
        <Route path="/staffing" element={<Staffing />} />
        <Route path="/staffing-solution-process" element={<StaffingSolution />} />
        <Route path="/services" element={<Services />} />
        <Route path="/web-development" element={<Web_devlopment />} />
        <Route path="/mobile-development" element={<Mobile_development />} />
        <Route path="/eCommerce" element={<ECommerce />} />
        <Route path="/managed-services" element={<ManagedServices />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact-us" element={<Countact_us />} />
        <Route path="/blog-page" element={<BlogPage />} />
        <Route path="/blog-detail" element={<BlogDetail />} />
        <Route path="/insights/blog/:category/:slug" element={<BlogDetailFormat />} />
        <Route path="/AI-ML-devlopment" element={<AIML_development />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;